import {Dot} from 'recharts';

import {isNil} from 'ramda';

import {PriceMapChartItem} from '../types/PriceMapChartItem';

const MY_VEHICLE_RADIUS = 5;
const MY_VEHICLE_COLOR = '#0A2442';

interface MyVehicleShapeProps {
  x?: number; // Passed by recharts
  y?: number; // Passed by recharts
  width?: number; // Passed by recharts
  payload?: PriceMapChartItem;
}

export function MyVehicleShape(props: MyVehicleShapeProps) {
  if (isNil(props.x) || isNil(props.width) || isNil(props.y)) {
    return null;
  }

  return (
    <Dot
      cx={props.x + props.width / 2}
      cy={props.y + MY_VEHICLE_RADIUS}
      r={MY_VEHICLE_RADIUS}
      fill={MY_VEHICLE_COLOR}
      stroke={MY_VEHICLE_COLOR}
      strokeOpacity={0.2}
      strokeWidth={16}
      pointerEvents="none"
    />
  );
}
